import React, { useRoutes } from 'react-router-dom';
import Layout from 'src/components/Layout/Layout';
import { ACTIONS } from 'src/utils/roles/actions';
import AccessControl from 'src/components/AccessControl';
import StatusCode403 from 'src/pages/StatusCode/403';
import StatusCode404 from 'src/pages/StatusCode/404';
import Test1 from 'src/pages/Test/Test1';
import Test2 from 'src/pages/Test/Test2';
import Login from 'src/pages/Login';
import TenantManagementLayout from 'src/pages/Tenant/TenantManagementLayout';
import VehicleTrackingReport from 'src/pages/VehicleTrackingReport';
import VehicleTrackingReportList from 'src/pages/VehicleTrackingReportList';
import VehicleTrackingList from 'src/pages/VehicleTrackingList';
import VarianceReportV2 from 'src/pages/VarianceReportV2';
import InwardReportWithExitTime from 'src/pages/InwardReportWithExitTime';
import InwardReport from 'src/pages/InwardReport';
import Settings from 'src/pages/Settings/Settings';
import Product from 'src/pages/Settings/Enterprise/Product/Product';
import User from 'src/pages/Settings/Enterprise/User/Users';
import Organisation from 'src/pages/Settings/Enterprise/Organisation/OrganisationList';
import Stage from 'src/pages/Settings/VehicleTracking/Stages/StageList';
import CreateStage from 'src/pages/Settings/VehicleTracking/Stages/CreateStage';
import PackTypeAssignment from 'src/pages/Settings/VehicleTracking/PackType/PackTypeAssignment';
import ProfileGeneral from 'src/pages/Settings/Profile/General';
import EventSyncLog from 'src/pages/Settings/SyncEvents/EventSyncLog';
import PendingGrnVehicleEntry from 'src/pages/PendingGrnVehicleEntry';
import VehicleTrackingDetailPage from 'src/pages/VehicleTrackingDetailPage';
import VehicleDetail from 'src/pages/VehicleDetail';
import CreateVehicleTracking from 'src/pages/CreateVehicleTracking/CreateVehicleTracking';
import StageDashboard from 'src/pages/StageDashboard';
import CreateQualityCheck from 'src/components/Settings/QualityCheck/CreateQualityCheck';
import Dimension from 'src/pages/Settings/Enterprise/Dimensions/DimensionList';
import CreateDimension from 'src/pages/Settings/Enterprise/Dimensions/CreateDimension';
import QualityCheckList from 'src/components/Settings/QualityCheck/QualityCheckList';
import VehicleTrackingPlanningForOutward from 'src/pages/Outward/VehicleTrackingPlanningForOutward';
import QualityCheckDetail from 'src/components/Settings/QualityCheck/QualityCheckDetail';
import { OverallDashboard } from 'src/pages/Dashboard/OverallDashboard';
import StationActivityLogList from 'src/pages/StationActivityLogList';
import CreateOutwardVehicleTracking from 'src/pages/Outward/CreateOutwardVehicleTracking';
import CreateVehicleTrackingPlanningForOutward from 'src/pages/Outward/CreateVehicleTrackingPlanningForOutward';
import CreateDuplicateVehicleTracking from 'src/pages/Outward/CreateDuplicateVehicleTracking';
import VehicleList from 'src/pages/Vehicle/VehicleList';
import VehicleTrackingLocationShare from 'src/pages/VehicleTrackingLocationShare';
import OutwardReport from 'src/pages/OutwardReport';
import OutwardVarianceReport from 'src/pages/OutwardVarianceReport';
import OutwardReportWithExitTime from 'src/pages/OutwardReportWithExitTime';
import Transporter from 'src/pages/TransporterList';

export default function Router() {
  const routes = useRoutes([
    {
      path: 'vehicle-tracking/location-share/:vehicleTrackingNumber',
      element: <VehicleTrackingLocationShare />,
    },
    {
      path: '/',
      element: <Layout />,
      children: [
        {
          index: true,
          element: <OverallDashboard />,
        },
        {
          path: 'test1/',
          element: (
            <AccessControl
              action={ACTIONS.TEST.VISIT}
              optionalChildren={<StatusCode403 />}
            >
              <Test1 />
            </AccessControl>
          ),
        },
        {
          path: 'test2/',
          element: <Test2 />,
        },
        {
          path: 'create-quality-check/',
          element: <CreateQualityCheck />,
        },
        {
          path: 'quality-check-list/',
          element: <QualityCheckList />,
        },
        {
          path: 'quality-check-detail/:qualityCheckUniqueNumber',
          element: <QualityCheckDetail />,
        },
        {
          path: 'vehicle-tracking/create/',
          element: (
            <AccessControl
              action={ACTIONS.VEHICLE_TRACKING.INWARD.CREATE}
              optionalChildren={<StatusCode403 />}
            >
              <CreateVehicleTracking />
            </AccessControl>
          ),
        },
        { path: 'report/:slug', element: <VehicleTrackingReport /> },
        {
          path: 'stations',
          children: [
            { index: true, element: <StageDashboard /> },
            {
              path: ':workFlowStageName/:workFlowStageUniqueNumber',
              element: <StageDashboard />,
            },
          ],
        },
        {
          path: '/:workflowStageId/:vehicleTrackingNumber',
          element: <VehicleTrackingDetailPage />,
        },
        {
          path: 'vehicle/:vehicleId',
          element: <VehicleDetail />,
        },
        {
          path: 'tenant-management/',
          element: <TenantManagementLayout />,
        },
        {
          path: 'report/',
          children: [
            {
              path: 'variance/',
              element: (
                <AccessControl
                  action={ACTIONS.REPORT.VARIANCE}
                  optionalChildren={<StatusCode403 />}
                >
                  <VarianceReportV2 />
                </AccessControl>
              ),
            },
            {
              path: 'vehicle-trackings/',
              element: (
                <AccessControl
                  action={ACTIONS.REPORT.VEHICLE_TRACKING}
                  optionalChildren={<StatusCode403 />}
                >
                  <VehicleTrackingReportList />
                </AccessControl>
              ),
            },

            {
              path: 'inward/',
              element: (
                <AccessControl
                  action={ACTIONS.REPORT.INWARD}
                  optionalChildren={<StatusCode403 />}
                >
                  <InwardReport />
                </AccessControl>
              ),
            },
            {
              path: 'inward-with-exit-time/',
              element: (
                <AccessControl
                  action={ACTIONS.REPORT.INWARD}
                  optionalChildren={<StatusCode403 />}
                >
                  <InwardReportWithExitTime />
                </AccessControl>
              ),
            },
            {
              path: 'outward/',
              element: (
                <AccessControl
                  action={ACTIONS.REPORT.OUTWARD}
                  optionalChildren={<StatusCode403 />}
                >
                  <OutwardReport />
                </AccessControl>
              ),
            },
            {
              path: 'outward-with-exit-time/',
              element: (
                <AccessControl
                  action={ACTIONS.REPORT.OUTWARD}
                  optionalChildren={<StatusCode403 />}
                >
                  <OutwardReportWithExitTime />
                </AccessControl>
              ),
            },
            {
              path: 'variance/outward/',
              element: (
                <AccessControl
                  action={ACTIONS.REPORT.OUTWARD}
                  optionalChildren={<StatusCode403 />}
                >
                  <OutwardVarianceReport />
                </AccessControl>
              ),
            },
          ],
        },
        {
          path: 'vehicle-tracking-list/',
          element: <VehicleTrackingList />,
        },
        {
          path: 'settings/',
          element: <Settings />,
        },
        {
          path: 'products/',
          element: <Product />,
        },
        {
          path: 'transporters/',
          element: <Transporter />,
        },
        {
          path: 'users/',
          element: <User />,
        },
        {
          path: 'organisation/',
          element: <Organisation />,
        },
        {
          path: 'stages/',
          element: <Stage />,
        },
        {
          path: 'stages/new/',
          element: <CreateStage />,
        },
        {
          path: 'pack-type-assignment/',
          element: <PackTypeAssignment />,
        },
        {
          path: 'general/',
          element: <ProfileGeneral />,
        },
        {
          path: 'account/',
          element: <EventSyncLog eventObjectKey={1} />,
        },
        {
          path: 'product/',
          element: <EventSyncLog eventObjectKey={2} />,
        },
        {
          path: 'purchase-order/',
          element: <EventSyncLog eventObjectKey={3} />,
        },
        {
          path: 'sales-order/',
          element: <EventSyncLog eventObjectKey={4} />,
        },
        {
          path: 'goods-received-note/',
          element: <EventSyncLog eventObjectKey={5} />,
        },
        {
          path: 'dimensions/',
          element: <Dimension />,
        },
        {
          path: 'dimensions/new/',
          element: <CreateDimension />,
        },
        {
          path: 'grn/list',
          element: (
            <AccessControl
              action={ACTIONS.REPORT.GRN}
              optionalChildren={<StatusCode403 />}
            >
              <PendingGrnVehicleEntry />
            </AccessControl>
          ),
        },
        {
          path: 'dashboard/',
          element: <OverallDashboard />,
        },
        {
          path: 'create-duplicate-vehicle-tracking/',
          element: <CreateDuplicateVehicleTracking />,
        },
        {
          path: 'station-activity-logs/',
          element: <StationActivityLogList />,
        },
        {
          path: 'outward/create/',
          element: (
            <AccessControl
              action={ACTIONS.VEHICLE_TRACKING.OUTWARD.CREATE}
              optionalChildren={<StatusCode403 />}
            >
              <CreateOutwardVehicleTracking />
            </AccessControl>
          ),
        },
        {
          path: 'outward/planning/',
          element: (
            <AccessControl
              action={ACTIONS.VEHICLE_PLANNING.VIEW}
              optionalChildren={<StatusCode403 />}
            >
              <VehicleTrackingPlanningForOutward />
            </AccessControl>
          ),
        },
        {
          path: 'vehicle-list/',
          element: <VehicleList />,
        },
        {
          path: 'outward/create-planning/:vehicleTrackingNumber',
          element: (
            <AccessControl
              action={ACTIONS.VEHICLE_PLANNING.EDIT}
              optionalChildren={<StatusCode403 />}
            >
              <CreateVehicleTrackingPlanningForOutward />
            </AccessControl>
          ),
        },
      ],
    },
    {
      path: 'login/',
      element: <Login />,
    },
    {
      path: '403/',
      element: <StatusCode403 />,
    },
    {
      path: '404/',
      element: <StatusCode404 />,
    },
    {
      path: '*',
      element: <StatusCode404 />,
    },
  ]);

  return routes;
}
